import $ from 'jquery';
import blocks from 'lib/analytics/blocks/index';
import anComponentView from 'lib/analytics/componentView';
import anClicks from 'lib/analytics/click';
import anAddContext from 'lib/analytics/context.add';
import recentVehicles from 'features/recentVehicles';

var toyotaCare = toyotaCare || {
  init: function (el) {
    var self = this;
    var $scope = $(el);

    self.analytics($scope);
  },

  analytics: function (scope) {
    var $scope = scope;
    var vehicle = recentVehicles.getMostRecentVehicle();

    anComponentView($scope, blocks.sectionBlock('toyota care'));

    $scope.find("a[href*='/content/ebrochure/']").each(function () {
      if (vehicle) {
        anAddContext(
          $scope,
          blocks.seriesBlock({
            series_code: vehicle.series,
            year: vehicle.year,
            grade: vehicle.trim || '',
            trim_code: vehicle.trimCode || ''
          })
        );
      }
      anAddContext($(this), blocks.sectionBlock('toyota care'));
    });

    $scope.find("a[href*='/dealers']").each(function () {
      if (vehicle) {
        anAddContext(
          $scope,
          blocks.seriesBlock({
            series_code: vehicle.series,
            year: vehicle.year,
            grade: vehicle.trim || '',
            trim_code: vehicle.trimCode || ''
          })
        );
      }
      anAddContext($(this), blocks.sectionBlock('toyota care'));
    });

    $scope.find("a[href*='/rav4ev']").each(function () {
      if (vehicle) {
        anAddContext(
          $scope,
          blocks.seriesBlock({
            series_code: vehicle.series,
            year: vehicle.year,
            grade: vehicle.trim || '',
            trim_code: vehicle.trimCode || ''
          })
        );
      }
      anAddContext($(this), blocks.sectionBlock('toyota care'));
    });

    anClicks($scope);
  }

};

export default toyotaCare;
